module.exports = __webpack_public_path__ + "static/media/CasperProfile.729fb16d.jpg";